;
define("quick_add_item.tpl", function(){});

